import React, { useEffect, useState } from "react";
import { usePatientImage } from "../hooks/usePatientImage";

/**
 * Avatar del paciente en círculo. Sin imagen por defecto: placeholder gris si no hay URL en gameTexts.
 * Solo muestra la imagen cuando ha cargado (onLoad) para evitar parpadeo.
 * width/height: en px; si no se pasa height, se usa width (círculo).
 */
export default function PatientAvatar({ gameId, width, height }) {
	const { patientImageUrl, ready } = usePatientImage(gameId);
	const [imageLoaded, setImageLoaded] = useState(false);
	const h = height != null ? height : width;
	const size = { width: width || 200, height: h };

	useEffect(() => {
		if (!patientImageUrl) setImageLoaded(false);
	}, [patientImageUrl]);

	if (!ready || !patientImageUrl) {
		return (
			<div
				className="patient-avatar-circle"
				style={{ ...size, background: "#e8e8e8" }}
				aria-hidden
			/>
		);
	}
	return (
		<div className="patient-avatar-circle" style={{ ...size, background: "#e8e8e8" }}>
			<img
				src={patientImageUrl}
				alt=""
				onLoad={() => setImageLoaded(true)}
				style={{
					width: "100%",
					height: "100%",
					objectFit: "cover",
					borderRadius: "50%",
					opacity: imageLoaded ? 1 : 0,
					transition: "opacity 0.15s ease-out",
				}}
			/>
		</div>
	);
}
